import { Injectable, inject } from '@angular/core';
import { AbstractSelectorListService } from '../shared/selector-list/services/abstract-selector-list.service';
import { SearchDto } from '../shared/selector-list/interfaces/search-dto.interface';
import { SelectorListResponse } from '../shared/selector-list/interfaces/selector-list-response.interface';
import { Observable, map } from 'rxjs';
import { AbstractPurchasingService } from './abstract-purchasing.service';
import { BuyerItem } from '../interfaces/buyer-item.interface';

@Injectable()
export class BuyerSelectorService extends AbstractSelectorListService<BuyerItem> {
  private purchasingService = inject(AbstractPurchasingService);

  getItems(dto: SearchDto, currentBuyerId?: string): Observable<SelectorListResponse<BuyerItem>> {
    return this.purchasingService.findBuyersByGroupAndUserName(dto).pipe(
      map(response => ({
        ...response,
        items: response.items.filter(item => item.id !== currentBuyerId)
      })),
    );
  }
}
